<template>
  <div class="container width-100 bg-slightGrey">
    <van-button @click="$router.go(-1)" class="mini-btn" type="primary" size="mini" plain color="rgb(232,214,168)">返回</van-button>

    <div class="main position-relative">
      <div class="width-100 top-box">
        <p class="fs-big black fw-mid margin-b">瑞安国旗教育馆</p>
        <p class="line position-absolute"></p>
        <p class="darkgrey">预约参观时间</p>
        <p class="black margin-ts margin-b">{{ sign.signDate }} {{ sign.timeslot.startTime + '-' + sign.timeslot.endTime }}</p>
        <p class="darkgrey">预约人</p>
        <p class="margin-ts margin-bs">
          <span class="black margin-r">{{ sign.signUsername }}</span>
          <span class="black margin-r">{{ '共' + sign.signNum + '人' }}</span>
          <span v-if="sign.childFlag === 1" class="black">携带孩子</span>
        </p>
        <p class="margin-ts margin-bs">
          <span class="black margin-r">{{ encryptPhone(sign.signMobile) }}</span>
          <span class="black margin-l">{{ encryptIdNo(sign.signIdnum) }}</span>
        </p>
      </div>
      <div class="textAlign-c">
        <p class="grey margin-b">核销时间：{{ sign.signAuthTime || '未核销' }}</p>
        <van-button
          v-if="sign.signAuthStatus === '0' && signAuthFlag"
          @click="handleSubmit"
          type="primary"
          native-type="submit"
          class="width-50 btn"
          color="linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21))"
          round
          >确认核销
        </van-button>
        <van-button
          v-if="sign.signAuthStatus === '1'"
          disabled
          type="primary"
          native-type="submit"
          class="width-50 btn"
          color="linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21))"
          round
          >已核销</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog, Notify } from 'vant';
import signApi from '@/api/signApi';
import moment from 'moment';
import config from '@/config';
/* eslint-disable no-undef,no-unused-vars */
import VConsole from 'vconsole';
export default {
  name: 'writeOffDetail',
  data() {
    return {
      signId: null,
      signAuthFlag: false,
      sign: {
        timeslot: {
          startTime: null,
          endTime: null
        }
      },
      env: null
    };
  },
  mounted() {
    let that = this;
    // 判断是否瑞安新闻进入
    CP.getClientInfo({
      completed: function (data) {
        console.log('getClientInfo', data);
        if (
          data.client_code == 'wx' ||
          window.navigator.userAgent.toLowerCase().includes('miniprogram/wx') ||
          window.__wxjs_environment === 'miniprogram'
        ) {
          that.env = 'wx';
          Notify({
            type: 'warning',
            message: '当前环境无法核销'
          });
        } else if (data.client_code == 'xsb_ruian') {
          that.env = 'xsb_ruian';
          CP.isLogin({
            completed: function (data) {
              console.log('isLogin', data);
              if (data.is_login === 1) {
                // 已登录， 获取用户信息
                CP.getCustomerInfo({
                  completed: function (data) {
                    console.log('getCustomerInfo', data);
                    console.log('authWhiteList', config.AUTH_WHITE_LIST);
                    console.log('mobile', data.mobile);
                    console.log(config.AUTH_WHITE_LIST.includes(data.mobile));
                    if (config.AUTH_WHITE_LIST.includes(data.mobile)) {
                      that.signAuthFlag = true;
                    }
                  },
                  cpIncompatible: function () {
                    console.log('此环境不支持此方法');
                  }
                });
              } else {
                // 未登录， 提示用户登录
                CP.showLogin({
                  completed: function (data) {
                    window.location.reload();
                    CP.tools.writelog('show_login', data);
                  },
                  cpIncompatible: function () {
                    CP.tools.writelog('', '此环境不支持此方法');
                  }
                });
              }
            },
            cpIncompatible: function () {
              console.log('此环境不支持此方法');
            }
          });
        } else {
          that.env = 'mobile';
          that.signAuthFlag = true;
        }
      },
      cpIncompatible: function () {
        CP.tools.writelog('', '此环境不支持此方法');
      }
    });

    this.signId = this.$route.query.signId;
    if (this.signId === undefined || this.signId === null) {
      Notify({
        type: 'warning',
        message: '参数错误'
      });
    } else {
      signApi.info(this.signId).then((res) => {
        this.sign = res.data;
      });
    }
  },
  methods: {
    handleSubmit() {
      Dialog.confirm({
        title: '预约核销',
        message: '确认要核销吗'
      }).then(() => {
        this.sign.signAuthStatus = 1;
        this.sign.signAuthTime = moment().format('yyyy-MM-DD HH:mm:ss');
        this.sign.signAuthBy = this.env;
        this.sign.signAuthCode = navigator.userAgent;
        signApi.save(this.sign).then((res) => {
          if (res.code === 200) {
            Notify({
              type: 'success',
              message: '核销成功'
            });
            this.$router.go(-1);
          } else {
            Notify({
              type: 'warning',
              message: res.msg
            });
          }
        });
      });
    },
    encryptIdNo(str) {
      if (null != str && str != undefined) {
        var pat = /(\d{6})\d*(\d{4})/;
        return str.replace(pat, '$1********$2');
      } else {
        return '';
      }
    },
    encryptPhone(str) {
      if (null != str && str != undefined) {
        var pat = /(\d{3})\d*(\d{4})/;
        return str.replace(pat, '$1****$2');
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn {
  box-shadow: 0 5px 2px rgba(0, 0, 0, 0.05);
}
.container {
  background: url('../../assets/image/bg1.jpg') no-repeat;
  background-size: 100%;
  padding: 100px 5% 40px;
  height: 100vh;
  overflow: hidden;
  .main {
    padding: 40px 20px;
    background: #ffffff;
    border-radius: 10px;
    min-height: 400px;
    height: auto;
    .line {
      top: 40px;
      left: 0;
      width: 4px;
      height: 20px;
      border-radius: 0 10px 10px 0;
      background: linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21));
    }
    .top-box {
      height: 250px;
    }
  }
}

.mini-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0);
  padding: 0;
  border: none;
}
</style>
